import React from 'react';
import PropTypes from 'prop-types';
import FieldGroup from '../FieldGroup';

export default class RegistrationFieldGroup extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    index: PropTypes.number.isRequired,
    metadata: PropTypes.object.isRequired,
    errorMessages: PropTypes.array
  };

  constructor(props) {
    super(props);
    this.renderChildren = this.renderChildren.bind(this);
    this.cloneChild = this.cloneChild.bind(this);
  }

  cloneChild(child) {
    if (child && child.key) {
      let field = this.props.metadata[child.key];
      let errorMessage = this.props.errorMessages ? this.props.errorMessages.find(error => error.field_name === child.key) : null;
      return React.cloneElement(child, {
        available: field ? field.available : true,
        editable: field ? field.editable : true,
        name: `[${this.props.index}][${child.key}]`,
        id: `[${this.props.index}][${child.key}]`,
        fieldName: child.key,
        errorMessage: errorMessage
      });
    }
    else {
      if (child) {
        return this.renderChildren(child);
      }
    }
  }

  renderChildren(element) {
    let children = element ? element.props.children : this.props.children;
    if (children) {
      if (Array.isArray(children)) {
        return children.map((child) => {
          return this.cloneChild(child);
        });
      } else {
        let child = React.Children.only(children);
        return this.cloneChild(child);
      }
    }
  }

  render() {
    if (this.props.metadata) {
      return (
        <FieldGroup {...this.props}>
          {this.renderChildren()}
        </FieldGroup>
      )
    } else {
      return null;
    }
  }
}
